document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-variant-select]');
  if (!select) return;
  const option = select.selectedOptions[0];
  document.querySelectorAll('[data-live-price]').forEach(el => el.textContent = option.dataset.price);
  const submit = select.form.querySelector('[data-product-submit]');
  if (submit && submit.dataset.ready === 'true') { submit.disabled = option.dataset.available !== 'true'; submit.textContent = submit.disabled ? submit.dataset.unavailableLabel : submit.dataset.addLabel; }
  const url = new URL(window.location.href); url.searchParams.set('variant', option.value); window.history.replaceState({}, '', url);
});
document.addEventListener('click', event => {const link=event.target.closest('a[href="#size-guide"]'); if(link){document.getElementById('size-guide').open=true;}});
